import { mount2faAuthentication } from '~/authentication/mount_2fa';

mount2faAuthentication();
